import { combineReducers } from "redux";
import {createItemReducer, createItemReducerParams} from "@mnjsplatform/data/lib/reducers/dataItemReducer";
export function subPositionResponsibilitiesReducer() {
    return combineReducers({
        AdmStruct_ListSubForPO: createItemReducer('SubPositionResponsibilities', 'AdmStruct.ListSubForPO', false),
        AdmStructBoss_GetAllSRSubs: createItemReducer('SubPositionResponsibilities', 'AdmStructBoss.GetAllSRSubs', false),
        Duties_DisplayForUser: createItemReducer('SubPositionResponsibilities', 'Duties.DisplayForUser', false),
        Duties_FiltersForPO: createItemReducer("SubPositionResponsibilities", "Duties.FiltersForPO", false),
        Duties_FiltersForPO_Params: createItemReducerParams("SubPositionResponsibilities", "Duties.FiltersForPO"),
    });
}